import BottomNav from './BottomNav';
import AnimatedOutlet from './AnimatedOutlet';

export default function AppLayout() {
  return (
    <div className="max-w-(--container-xs) h-screen mx-auto flex flex-col bg-white pt-safe sm:rounded-md sm:border sm:pt-0">
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        <AnimatedOutlet />
      </div>
      <BottomNav />
    </div>
  );
}
